import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { themeGet } from 'styled-system'
import { SiteSelectorK8WrapperDark as BaseSiteSelectorK8WrapperDark } from 'components/SiteSelector'
import { BodyCopy, HeaderTwo } from 'secondstep-components'

export const UnitV3PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const UnitV3InnerWrapper = styled.div`
  width: 100%;
  max-width: 85.375rem;
  padding: 0 1rem;
`

export const UnitV3LessonPageWrapper = styled.div`
  width: 100%;
  max-width: 85.375rem;
`

export const UnitV3ContentWrapper = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 85.375rem;
  padding: 1.3125rem 1.25rem 0 1.25rem;

  [data-testid='course-instance-header'] {
    margin-bottom: 1.25rem;
  }
`

export const UnitV3TopNavigation = styled.nav`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1.625rem;
`

export const UnitV3SiteSelectorWrapper = styled(BaseSiteSelectorK8WrapperDark)`
  padding: 0;
`

export const UnitV3SectionWrapper = styled.div`
  width: 100%;
`

export const UnitV3BodyBackground = styled.div`
  width: 100%;
  margin-top: -6.25rem;
  padding: 6.75rem 1rem 2rem;
  background-color: #f3f4f6;
`

export const UnitV3SectionHeader = styled.div`
  width: 100%;
  margin-top: 1.75rem;
  margin-bottom: 0.75rem;

  ${HeaderTwo} {
    margin: 0;
  }
`

export const UnitV3OverviewBox = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1.25rem;

  & > * {
    width: 100%;
  }

  ${BodyCopy} {
    max-width: 50rem;
  }

  @media (max-width: 48rem) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const UnitV3TrainingCardLink = styled(Link)`
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
`

export const UnitV3TrainingCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-top: 0.75rem;
  padding: 1.5rem;
  border-radius: 0.75rem;
  border: 0.125rem solid
    ${themeGet(
      'tieredInterventionUnitCard.styledContainer.borderColor.primary',
    )};
  background: #ffffff;
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  &:hover {
    border: 0.125rem solid
      ${themeGet(
        'tieredInterventionUnitCard.styledContainer.borderColor.hover',
      )};
  }
`

export const UnitV3TrainingDot = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 0.09375rem solid #7797ab;
  margin-top: 0.375rem;
  flex-shrink: 0;
`

export const UnitV3TrainingText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`

export const UnitV3TrainingTitle = styled.h3`
  margin: 0;
  color: #0d3458;
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-family: ${({ theme }) => theme.font?.sharpSlab?.bold || 'inherit'};
`

export const UnitV3TrainingDescription = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 0.9375rem;
  line-height: 1.25rem;
`

export const BannerSpacer = styled.div`
  margin-top: 7rem;
`

export const PreviewBannerWrapper = styled.div`
  > div:nth-child(2) {
    margin-top: -6.99rem !important;
    margin-bottom: 0 !important;
  }
`
